import { Modal as AntdModal, ModalProps } from 'antd';
import React, { FC, useState } from 'react';
import Draggable from 'react-draggable';

type Props = ModalProps & {
  isMobile?: boolean;
  'data-testid'?: string;
};

export const Modal: FC<Props> = ({ title, isMobile, 'data-testid': dataTestId, ...props }) => {
  const [draggable, setDraggable] = useState(false);

  return (
    <AntdModal
      {...props}
      title={
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        <div onMouseOver={() => setDraggable(true)} onMouseOut={() => setDraggable(false)}>
          {title}
        </div>
      }
      modalRender={
        isMobile
          ? (modal) => <div data-testid={dataTestId}>{modal}</div>
          : (modal) => (
              <Draggable disabled={!draggable}>
                <div data-testid={dataTestId}>{modal}</div>
              </Draggable>
            )
      }
    />
  );
};
